import { useApp } from '@libs/hooks';
import React from 'react';
import { TextCommon } from '../../UI/Text/TextCommon';
import styles from '../Calculator.module.css';

type TCalculatorFeeButtonProps = {
    enterCodePopup: React.ReactNode;
    appliedCodePopup: React.ReactNode;
    handlingAutoApplied?: boolean;
    label: string;
    value?: string;
};

const CodeButton = React.memo(({ enterCodePopup, appliedCodePopup, label, value, handlingAutoApplied }: TCalculatorFeeButtonProps) => {
    const { setPopup } = useApp();
    const handleClick = () => {
        setPopup(value || handlingAutoApplied ? appliedCodePopup : enterCodePopup);
    };
    return (
        <button className={styles.feePanelButton} onClick={handleClick}>
            <TextCommon isWidget={false} content={label} options={{ variant: 'secondary', textColor: 'purple_100' }} />
        </button>
    );
});
export { CodeButton };
